export default __webpack_public_path__ + "static/media/banner_3.b48e4f42.jpg";